import React, { useCallback } from 'react';
import { useWelcomeEmail } from '../../hooks/useWelcomeEmail';
import FileDownload from '../../containers/FileDownload';

const WelcomeEmailInstruction = () => {
  const { fetchInstruction } = useWelcomeEmail();
  const downloadInstruction = useCallback(() => fetchInstruction(), [fetchInstruction]);
  return <FileDownload downloadFn={downloadInstruction} />;
};

export default WelcomeEmailInstruction;
